<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>基本信息</el-breadcrumb-item>
            <el-breadcrumb-item>人员信息</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form class="form" :model="form" size="small" label-width="100px" ref="form">
            <el-form-item label="编号" prop="id" class="input_400">
                <el-input v-model="form.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名" prop="username" class="input_400">
                <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="mobile" class="input_400">
                <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" class="input_400">
                <el-input v-model="form.email"></el-input>
            </el-form-item>
            <!-- <el-form-item label="身份证" prop="idcd" class="input_400">
                <el-input v-model="form.idcd"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="addr" class="input_400">
                <el-input v-model="form.addr"></el-input>
            </el-form-item> -->
            <el-form-item label="性别" prop="sex" class="input_400">
                <el-radio v-model="form.sex" v-for="e in sex" :key="e.value" :label="e.value">{{ e.text }}</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="updateCurUser" :loading="saving">确认</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                id: '',
                username: '',
                mobile: '',
                email: '',
                idcd: '',
                addr: '',
                sex: ''
            },
            sex: [
                {
                    text: '男',
                    value: 1
                },
                {
                    text: '女',
                    value: 0
                },
                {
                    text: '保密',
                    value: 2
                }
            ],
            saving: false
        }
    },
    computed: {
        userInfo() {
            let userInfo = JSON.parse(sessionStorage.getItem('session'))
                .userInfo
            if (userInfo) {
                return userInfo
            }
            return ''
        }
    },
    mounted() {
        this.form = this.userInfo
        // this.myInfo();
    },
    methods: {
        myInfo() {
            this.ajax.get('/principal/getCurUser').then(data => {
                this.form = data
            })
        },
        setSession() {
            let dataSession = JSON.parse(sessionStorage.getItem('session'))
            dataSession.userInfo = this.form
            sessionStorage.setItem('session', JSON.stringify(dataSession))
        },
        updateCurUser() {
            console.log(this.form);
            this.saving = true
            this.ajax.post('/user/admin/updateUserMessage', this.form).then(data => {
                this.$message({
                    type: 'success',
                    message: '操作成功！',
                })
                this.saving = false
                this.setSession();

            }).catch(() => {
                this.saving = false
            })
        },


    }

}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/basic/myMessage.vue